import { useEffect, useState } from 'react';
import styles from '../../styles/modules/components/SelfServe/self-serve-progress.module.scss';

const ProgressStep  = (props) => {
    const [small_screen,setLyaout] = useState(true);
    useEffect(() => {
        window.innerWidth > 992 ? setLyaout(false) : setLyaout(true);
        window.addEventListener('resize',() => {
            if(window.innerWidth > 992) {
                small_screen ? setLyaout(!small_screen) : '';
            }
            else {
                !small_screen ? setLyaout(!small_screen) : '';
            }
        });
    })
    return(

        <div className={`${styles.progress_wrap} container`}>
            {
                small_screen ?
                (
                    <div className={styles.cart_progress}>
                        {props.landed_on_page === "" &&
                        <div className={styles.cart_progress__counter}>
                            <span>{props.step_number}</span>/ <span>3</span>
                        </div>
                        }
                        <div className={styles.cart_progress__txt}>
                          <h4>{props.step_number===2 && 'Service Details'}</h4>
                          {props.upload_document && <h4>{props.step_number === 4 && 'Upload Documents'}</h4>}
                          <h4>{props.step_number===3 && 'Select Address'}</h4>
                        </div>
                    </div>

                )
                :
                (

                        <div className={styles.cart_progress}>
                            <div className={styles.cart_progress__steps}>
                                <span data-active={props.step_number===2}>Service Details</span>
                                {props.upload_document && <span data-active = {props.step_number === 4}>Upload Documents</span>}
                                <span data-active={props.step_number===3}>Appointment Details</span>
                            </div>
                        </div>

                )
            }
        </div>

    )
}


export default ProgressStep;
